const APP =
  window && window.APP
    ? window.APP
    : {
        basePath: '',
        page: {
          id: 122,
          route: '',
          type: 'page',
          edited: false,
          enabled: true,
        },
        analytics: {
          code: '',
          host: 'none',
        },
        metaAnalytics: {
          code: '',
        },
        lang: 'en',
        denomination: 100,
        moneyTemplateCredits: 122266,
        moneyTemplateNr: '1,222.66',
        moneyTemplate: '€1,222.66',
        datePHPTemplate: 'yyyy-MM-dd',
        userSyncTimeout: 60000,
        alertAfterForFunGames: '10',
      }

APP.simpleLay = document.querySelector('html').className.indexOf('simple') > -1

module.exports = APP

// clearing global APP
// window.APP = {};
